/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GearSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128.00098}
        cy={128.00195}
        r={44}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M197.40919,80.65057a83.91174,83.91174,0,0,1,6.28744,10.91L229.6429,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.714,164.433a83.912,83.912,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26983,227.04288a103.88979,103.88979,0,0,1-38.17095-22.00126l.49974-29.68828a83.91174,83.91174,0,0,1-6.28744-10.91005L26.36491,150.0399a103.88962,103.88962,0,0,1-.03182-44.05764L52.29376,91.5709a83.9124,83.9124,0,0,1,6.30466-10.9001L58.099,50.999A103.88973,103.88973,0,0,1,96.23811,28.94259l25.46094,15.27693a83.91061,83.91061,0,0,1,12.59209.00995L159.738,28.961a103.88951,103.88951,0,0,1,38.171,22.00126Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default GearSix;
